import { safeDeleteSheet } from "@/lib/office-helpers";

const ROOMS: (string | number)[][] = [
  [12, "Sierra", 2700, 3600, 2880, 2700],
  [15, "Redwood", 2780, 3720, 2980, 2790],
  [20, "Sequoia", 3020, 4025, 3220, 3020],
  [25, "Fern", 3880, 5175, 4140, 3880],
  [30, "Vista", 4940, 6010, 5270, 4940],
  [30, "Seascape", 4940, 6590, 5270, 4940],
  [35, "Outlook", 5180, 6000, 5530, 5180],
  [50, "Peaks", 8440, 10000, 9000, 8440],
  [75, "Sunshine", 9375, 11150, 10000, 9375],
];

export async function startProject20(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Salas");

    const sheet = context.workbook.worksheets.add("Salas");
    sheet.getRange("A1:F1").merge();
    sheet.getRange("A1").values = [["Salas de Banquetes"]];
    sheet.getRange("A1").format.font.size = 36;
    sheet.getRange("A1").format.font.color = "#6F5FB8";

    const table = sheet.tables.add("A2:F2", true);
    table.name = "SalasBanquete";
    table.getHeaderRowRange().values = [[
      "Capacidad",
      "Nombre de la sala",
      "Primavera\nMar - May",
      "Verano\nJune -",
      "Otoño\nSept - Nov",
      "Invierno\nDec- Feb",
    ]];
    table.rows.add(undefined, ROOMS);
    table.style = "TableStyleMedium22";
    table.showBandedRows = false;
    sheet.getRange("C3:F11").numberFormat = Array(ROOMS.length).fill([
      "0",
      "0",
      "0",
      "0",
    ]);
    sheet.getRange("A:F").format.columnWidth = 110;
    // No activar wrapText — eso es la tarea 5 del alumno
    sheet.getRange("2:2").format.wrapText = false;

    sheet.activate();
    sheet.getRange("A1").select();
    await context.sync();
  });
}
